import React from "react";
import { AlertProvider } from "../components/utils/CustomAlert/useCustomAlert";
import { JobProvider } from "../hooks/Jobs";
import { ProyectoProvider } from "../data/ProyectoContext";
import { RespuestaProvider } from "../data/RespuestaContext";
import { ActividadesProvider } from "../components/UmmIACategories/Hook/useActividades";
import { ProjectsProvider } from "../context/Projects/ProjectContext";
import MainLayout from "./MainLayout";

//Layout para intranet
function MainProviders({ children }: { children: React.ReactNode }) {
  return (
    <AlertProvider>
      <JobProvider>
        <ProyectoProvider>
          <RespuestaProvider>
            <ActividadesProvider>
              <ProjectsProvider>
                <MainLayout>{children}</MainLayout>
              </ProjectsProvider>
            </ActividadesProvider>
          </RespuestaProvider>
        </ProyectoProvider>
      </JobProvider>
    </AlertProvider>
  );
}

export default MainProviders;
